import Swiper from "@theme/swiper";
export default class FeaturedProducts extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector(".featured-products__slider");
  }

  connectedCallback() {
    this.initSlider();
  }
  initSlider() {
    this.swiper = new Swiper(this.slider, {
      slidesPerView: "auto",
      spaceBetween: 16,
      speed: 1000,
      loop: true,
      initialSlide: 1,
      centeredSlides: true,
      breakpoints: {
        750: {
          initialSlide: 0,
          centeredSlides: false,
          spaceBetween: 40,
        },
        1800: {
          spaceBetween: 48,
        },
      },
    });
  }
}

customElements.define("featured-products", FeaturedProducts);
